import React, { Component,  } from 'react';
import '../../components/course/styling/MyPatProgressCircle.css'


interface MyPatCircleProps {
    percentage:string,
    color:string,
    innerText:string
}


interface MyPatCircleState {
}


class MyPatCircleProgress extends Component<MyPatCircleProps, MyPatCircleState>{

    constructor(props: MyPatCircleProps, state: MyPatCircleState) {
        super(props);
    }

    render() {
        const{color,percentage,innerText} = this.props;
        return (
            <div className={`c100 small margintop20 p${percentage}`}>
                <span>{innerText}</span>
                <div className="slice">
                    <div className="bar" style={{border:`0.08em solid ${color}`}}></div>
                    <div className="fill"  style={ parseInt(percentage) > 50 ? { border:`0.08em solid ${color}`} : {}}></div>
                </div>
            </div>
        )
    }
}


// @ts-ignore
export default (MyPatCircleProgress);

